import React from 'react'
import { Routes, Route } from "react-router-dom";
import Login from '../components/auth/Login';
import LayOut from '../components/Layout/LayOut';
// import WelcomeScreen from '../components/Layout/WelcomeScreen';
import CreateRoom from '../components/core/CreateRoom';
import VoiceToText from '../components/core/VoiceToText';
const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LayOut/>} >
        {/* <Route index element={<WelcomeScreen/>} /> */}
        <Route index element={<CreateRoom />} />
        <Route path="login" element={<Login/>} />
        <Route path="voice-to-text" element={<VoiceToText />} />
      </Route>
    </Routes>
  )
}

export default AppRoutes